import gql from 'graphql-tag';

export const CREATIVE_TEMPLATE_EDITOR_QUERY = gql`
  query CreativeTemplateEditorQuery($id: ID!) {
    articleGroup(id: $id) {
      id
      title
      url
      description
      postTexts {
        id
        text
        language
        isBlank
        postMaloneScore {
          engagementScore
          sourceType
        }
      }
      headlines {
        id
        text
        language
        isBlank
        isAutofilled
        postMaloneScore {
          engagementScore
          sourceType
        }
      }
      descriptions {
        id
        text
        isBlank
        isAutofilled
      }
      postMaloneProject {
        id
        externalProjectId
        postMaloneAccount {
          id
          name
          externalAccountId
        }
      }
      articleGroupOgTags {
        ogArticleAuthor
        ogArticlePublishedTime
        ogArticleSection
        ogArticleTags
      }
      policy {
        canUseNonPostMaloneTextAssets
        canCreatePostMaloneProject
      }
      ogImages {
        id
        url
      }
      articles {
        id
        title
        deprecated
        facebookPageId
        facebookLeadgenForms {
          id
          name
          externalId
          spec
          discardedAt
          createdAt
        }
        campaign {
          id
          name
          campaignObjective
          flipperFeatures {
            name
            enabled
          }
          publisher {
            enableAiImagesGeneration
          }
          campaignFacebookPages {
            id
            facebookPageId
            facebookPageDisplayName
          }
          pageLockedArticlesEnabled
        }
      }
    }
  }
`;
